// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	palette: {
		primary: {
			main: "#1976d2", // Blue
		},
		secondary: {
			main: "#9c27b0", // Purple
		},
		background: {
			default: "#f5f5f5", // Light gray
			paper: "#ffffff", // White for paper elements
		},
		text: {
			primary: "#333333", // Dark gray
			secondary: "#666666", // Lighter gray
		},
	},
	typography: {
		fontFamily: "Roboto, Arial, sans-serif",
		h1: {
			fontSize: "2rem",
			fontWeight: 600,
		},
		h2: {
			fontSize: "1.75rem",
			fontWeight: 500,
		},
		body1: {
			fontSize: "1rem",
			color: "#333333",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none", // Disable uppercase for buttons
					borderRadius: 8, // Rounded corners
				},
			},
		},
		MuiAppBar: {
			styleOverrides: {
				root: {
					// No background color defined here; it will use the default.
				},
			},
		},
	},
});

export default theme;
